import { render, staticRenderFns } from "./tempPelarasan012012.vue?vue&type=template&id=19531ada&scoped=true&"
import script from "./tempPelarasan012012.vue?vue&type=script&lang=js&"
export * from "./tempPelarasan012012.vue?vue&type=script&lang=js&"
import style0 from "./tempPelarasan012012.vue?vue&type=style&index=0&id=19531ada&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19531ada",
  null
  
)

export default component.exports